import type { ScheduledTriggerConfig } from '@lighthouse/shared'
import { isValid, lightFormat } from 'date-fns'
import React, { useMemo } from 'react'

import { rulesOptions } from '../../../NodeSetting/Triggers/ScheduledTriggerConfigure/CommonRule'
import * as CM from '../styles'
import * as SC from './styles'

type ScheduledCardProps = {
    config: ScheduledTriggerConfig
}

const dateFormat = 'yyyy/MM/dd HH:mm:ss'
const ScheduledCard: React.FC<ScheduledCardProps> = ({ config }) => {
    const { scheduleStartTime, scheduleRule = 'ONCE' } = config

    const scheduleRuleName = useMemo(() => {
        return rulesOptions.find(item => item.value === scheduleRule)?.label
    }, [scheduleRule])

    const date = useMemo(() => {
        const dateValue = scheduleStartTime && isValid(new Date(scheduleStartTime)) ? new Date(scheduleStartTime) : undefined
        if (!dateValue) {
            return null
        }
        return lightFormat(dateValue, dateFormat)
    }, [scheduleStartTime])

    return (
        <CM.CardItemContainer>
            <SC.TypeName>定时触发</SC.TypeName>

            <CM.FieldList>
                {scheduleStartTime && (
                    <CM.FieldItem>
                        <CM.FieldItemTitle>开始时间</CM.FieldItemTitle>
                        <SC.FieldItemRightTitle>{date}</SC.FieldItemRightTitle>
                    </CM.FieldItem>
                )}

                <CM.FieldItem>
                    <CM.FieldItemTitle>重复规则</CM.FieldItemTitle>
                    <SC.FieldItemRightTitle>{scheduleRuleName}</SC.FieldItemRightTitle>
                </CM.FieldItem>
            </CM.FieldList>
        </CM.CardItemContainer>
    )
}

export default ScheduledCard
